import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-preview-modal',
  templateUrl: './preview-modal.component.html',
  styleUrls: ['./preview-modal.component.scss']
})
export class PreviewModalComponent implements OnInit {
  /*modalHeader: string;
  modalContent: string;*/
  contentTitle: string;
  contentType: string;
  contentExt: string;
  modalSize: string;
  contentDimensions: string;
  contentAuthor: string;
  contentModifiedOn: string;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.activeModal.close();
    //return false;
  }
  successModal()
  {
    console.log("clicked on ok");
    this.activeModal.close();
  }

  cancelModal()
  {
     console.log("clicked on abort");
     this.activeModal.close();
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/preview-modal/preview-modal.component.ts